<wl-content-section [id]="id()" [theme]="theme()">
  @if (title() && linkLists(); as linkLists) {
    <wl-link-list-section
      [title]="title()!"
      [linkLists]="linkLists"
      [introduction]="introduction()!"
    />
  }
</wl-content-section>
